module.exports = __webpack_public_path__ + "img/kitesurf_avanzado.600cc367.jpg";